export const HARVEST_CREATE_FLOW = 'harvest_create'
export const HARVESTING_FLOW = 'harvesting'
export const HARVESTING_FLOW_ROUTE = '/harvesting'
export const HARVEST_BASED_HARVESTING_FLOW_ROUTE = `${HARVESTING_FLOW_ROUTE}/:id`
